import MicrosoftIcon from "./images/microsoft-auth.png";
import GoogleIcon from "./images/google-auth.png";

export const GOOGLE_AUTH_ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2";
export const GOOGLE_AUTH_APPLE_URL =
  "https://apps.apple.com/us/app/google-authenticator/id388497605";

export const MICROSOFT_AUTH_ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.azure.authenticator";
export const MICROSOFT_AUTH_APPLE_URL =
  "https://apps.apple.com/us/app/microsoft-authenticator/id983156458";

export const AUTH_APPS_LIST = [
  {
    icon: GoogleIcon,
    title: "Google Authenticator",
    linkAndroid: GOOGLE_AUTH_ANDROID_URL,
    linkApple: GOOGLE_AUTH_APPLE_URL,
  },
  {
    icon: MicrosoftIcon,
    title: "Microsoft Authenticator",
    linkAndroid: MICROSOFT_AUTH_ANDROID_URL,
    linkApple: MICROSOFT_AUTH_APPLE_URL,
  },
];
